module.exports = __webpack_public_path__ + "img/arrow.013a80fe.svg";